<template>
  <!-- contenedor -->
  <v-container fluid>
    <!-- Slot para la tarjeta de header -->
    <slot name="header"></slot>
    <!-- Slot para la lista de elementos -->
    <slot name="items"></slot>
    <!-- Paginación -->
    <v-row v-if="items.totalPages > 1">
      <!-- Columnas para la paginación -->
      <v-col cols="12">
        <!-- Paginación -->
        <v-pagination
          v-model="page"
          :length="items.totalPages"
          @input="$emit('update-page', page)"
          color="secondary"
          circle
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ListLayout",
  props: {
    items: {
      type: Object,
      required: true,
      default: () => {
        return { docs: [], totalPages: 0 };
      }
    }
  },
  data: () => {
    return {
      page: 1
    };
  }
};
</script>

<style scoped></style>
